import { render, staticRenderFns } from "./DocumentBuilder.vue?vue&type=template&id=6ca2ac52&scoped=true&"
import script from "./DocumentBuilder.vue?vue&type=script&lang=js&"
export * from "./DocumentBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2ac52",
  null
  
)

export default component.exports